/* eslint no-underscore-dangle: 0 */
import React, {
  useState, useEffect, useContext,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import Typography from '@digital-hig/mui/dist/Typography';
import window from 'global/window';
// eslint-disable-next-line import/no-extraneous-dependencies
import RadioGroup from '@mui/material/RadioGroup';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormControlLabel from '@mui/material/FormControlLabel';
// eslint-disable-next-line import/no-extraneous-dependencies
import DHAnalytics from '@adsk/dh-analytics/dist/js/DHAnalytics';
import EnvContext from '../common/envContext';
import {
  styleVariables, ENVIRONMENT, ENVIRONMENT_CONSTANTS, LEARNING_MODE_MICROLEARNING,
  LEARNING_MODE_COURSEWARE,
} from '../common/constants';
import { pushEvent } from '../common/analyticsApi';

const WTIH = ({
  tutorialName, tutorialType, tutorialId, curatedId, curatedName, unitId, learningMode,
}) => {
  const noFeedbackData = [
    {
      value: 'The information was difficult to understand',
      commentLabel: 'Please tell us why',
      payload: 'Quality',
    },
    {
      value: 'It wasn\'t what I was looking for',
      commentLabel: 'Please tell us what you were looking for',
      payload: 'Findability',
    },
    {
      value: 'It didn\'t address my needs',
      commentLabel: 'Please tell us why it didn\'t address your needs',
      payload: 'Incomplete',
    },
    {
      value: 'Something else',
      commentLabel: 'Please share your comments',
      payload: 'Other',
    },
  ];

  const [showWTIH, setShowWTIH] = useState(false);
  const [showThankMsg, setShowThankMsg] = useState(false);
  const [selectedFedbackOption, setSelectedFeedbackOption] = useState(null);
  const [commentVal, setCommentVal] = useState('');
  const [count, setCount] = useState(0);
  const [payload, setPayload] = useState(null);
  const [enabledNoFeedbackForm, setEnableNoFeedbackForm] = useState(false);
  const [enabledYesFeedbackForm, setEnableYesFeedbackForm] = useState(false);
  const [tutorialAndCuratedInfo, setTutorialAndCuratedInfo] = useState({});

  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];

  const buildTutorialAndCuratedInfo = () => {
    const d = {};
    d.tutorialInfo = {
      id: tutorialId,
      name: tutorialName,
      type: tutorialType,
    };
    if (curatedId && curatedName) {
      d.curatedListInfo = { name: curatedName, id: curatedId };
    }
    setTutorialAndCuratedInfo(d);
  };

  useEffect(() => {
    const isWTIHSubmittedAlready = window?.sessionStorage.getItem(`feedback-set-${document.location.href}`);
    if (!isWTIHSubmittedAlready) {
      setShowWTIH(true);
      setShowThankMsg(false);
      // dhaqInit();
    } else {
      setShowWTIH(false);
      setShowThankMsg(true);
    }
  }, [tutorialId, unitId]);

  useEffect(() => {
    buildTutorialAndCuratedInfo();
    setEnableNoFeedbackForm(false);
    setEnableYesFeedbackForm(false);
  }, [tutorialName, tutorialType, tutorialId, curatedId, curatedName, unitId]);

  const triggerEventToADP = (value) => {
    const { curatedListInfo } = tutorialAndCuratedInfo;
    DHAnalytics.logWithTracking({
      appId: ENVIRONMENT_CONSTANTS[env].WTIH.APPID,
      env,
      ADPData: {
        apiKey: ENVIRONMENT_CONSTANTS[env].WTIH.APIKEY,
        signWith: ENVIRONMENT_CONSTANTS[env].WTIH.SECRET,
      },
      event: 'helpful',
      value,
      ...(learningMode === LEARNING_MODE_MICROLEARNING && {
        data: {
          cm_tutorial_type: tutorialType,
          cm_tutorial_id: tutorialId,
          ...(curatedListInfo && { cm_curatedList_id: curatedListInfo.id }),
        },
      }),
      ...(learningMode === LEARNING_MODE_COURSEWARE && {
        data: {
          cm_unit_id: unitId,
          cm_module_Id: tutorialId,
          cm_module_type: tutorialType,
          ...(curatedListInfo && { cm_course_id: curatedListInfo.id }),
        },
      }),
    });
  };

  const handleOnChange = (value, payloadVal) => {
    setSelectedFeedbackOption(value);
    setCommentVal('');
    setCount(0);
    setPayload(payloadVal);
  };

  const handleCommentOnChange = (e) => {
    const val = e.target.value;
    setCommentVal(val);
    setCount(val.length);
  };

  const adobeAnalytics = (title) => {
    const { tutorialInfo, curatedListInfo } = tutorialAndCuratedInfo;
    const event = {
      event: {
        eventType: 'link_click',
      },
      link: {
        linkSection: 'content helpfulness',
        linkTitle: title,
      },
      akn: {
        eventName: `akn_content_helpfulness_${title}`,
      },
      ...(learningMode === LEARNING_MODE_MICROLEARNING && {
        tutorialInfo,
        ...(curatedListInfo && { curatedListInfo }),
      }),
      ...(learningMode === LEARNING_MODE_COURSEWARE && {
        [curatedListInfo ? 'courseInfo' : 'moduleInfo']: {
          unitId,
          moduleId: tutorialId,
          moduleType: tutorialType,
          ...(curatedListInfo && { courseId: curatedListInfo.id }),
        },
      }),
    };
    pushEvent({ event });
  };

  const handleNo = () => {
    setEnableNoFeedbackForm(true);
    setEnableYesFeedbackForm(false);
    setCommentVal('');
    setCount(0);

    // ADP
    triggerEventToADP('no');
    // Adobe Analytics
    adobeAnalytics('no');
  };

  const handleYes = () => {
    setEnableNoFeedbackForm(false);
    setEnableYesFeedbackForm(true);
    setSelectedFeedbackOption(true);
    setCommentVal('');
    setCount(0);

    // ADP
    triggerEventToADP('yes');
    // Adobe Analytics
    adobeAnalytics('yes');
  };

  const handleSubmit = () => {
    const { tutorialInfo, curatedListInfo } = tutorialAndCuratedInfo;
    DHAnalytics.logWithTracking(
      {
        appId: ENVIRONMENT_CONSTANTS[env].WTIH.APPID,
        env,
        ADPData: {
          apiKey: ENVIRONMENT_CONSTANTS[env].WTIH.APIKEY,
          signWith: ENVIRONMENT_CONSTANTS[env].WTIH.SECRET,
        },
        event: 'helpful_comment',
        value: enabledNoFeedbackForm ? 'no' : 'yes',
        data: {
          ...{ uc: window?.encodeURIComponent(commentVal).replace(/%20/g, ' ') },
          ...(enabledNoFeedbackForm && { hi: payload }),
        },
      },
    );

    // adobe analytics
    if (enabledNoFeedbackForm) {
      const event = {
        event: {
          eventType: 'link_click',
        },
        link: {
          linkSection: 'content helpfulness',
          linkTitle: payload,
        },
        ...(learningMode === LEARNING_MODE_MICROLEARNING && {
          tutorialInfo,
          ...(curatedListInfo && { curatedListInfo }),
        }),
        ...(learningMode === LEARNING_MODE_COURSEWARE && {
          [curatedListInfo ? 'courseInfo' : 'moduleInfo']: {
            unitId,
            moduleId: tutorialId,
            moduleType: tutorialType,
            ...(curatedListInfo && { courseId: curatedListInfo.id }),
          },
        }),
      };
      pushEvent({ event });
    }

    window?.sessionStorage.setItem(`feedback-set-${document.location.href}`, 'submitted');
    setShowWTIH(false);
    setShowThankMsg(true);
  };

  const submitFeedbackBtn = () => (
    <Button
      className="submit-feedback-btn"
      disabled={!(count > 0)}
      layout="hug"
      size="defaultSize"
      variant="contained"
      onClick={handleSubmit}
    >
      Submit feedback
    </Button>
  );

  const commentBox = ({ commentlabel }) => (
    <div className="share-your-comments">
      <Typography variant="body-copy-small">
        {commentlabel}
      </Typography>
      <textarea rows={2} maxLength="300" onChange={handleCommentOnChange} value={commentVal} placeholder="NOTE: Your comments here can only be seen by our editor" />
      <Typography
        className="comment-count"
        color="ink-on-background-disabled"
        variant="caption"
      >
        {`${count}/300`}
      </Typography>
    </div>
  );

  return (
    <RootElement>
      {showWTIH
        ? (
          <>
            <div className="actions">
              Was this information helpful?
              <Button
                layout="hug"
                size="defaultSize"
                variant={enabledYesFeedbackForm ? 'contained' : 'outlined'}
                onClick={handleYes}
              >
                Yes
              </Button>
              <Button
                layout="hug"
                size="defaultSize"
                variant={enabledNoFeedbackForm ? 'contained' : 'outlined'}
                onClick={handleNo}
              >
                No
              </Button>
            </div>
            {enabledYesFeedbackForm && (
              <div className="feedback-panel">
                <div className="yes">
                  {commentBox({ commentlabel: 'Do you have additional feedback about this information?' })}
                </div>
                {submitFeedbackBtn()}
              </div>
            )}
            {enabledNoFeedbackForm && (
              <div className="feedback-panel">
                <Typography variant="body-copy-small">
                  Why wasn&apos;t this information helpful?
                </Typography>
                <FormControl
                  component="fieldset"
                  InputLabelProps={{
                    component: 'legend',
                  }}
                >
                  <RadioGroup>
                    {noFeedbackData.map((f) => (
                      <>
                        <FormControlLabel
                          className="no-feedback-label"
                          key={f.value}
                          control={<Radio />}
                          onChange={() => handleOnChange(f.value, f.payload)}
                          value={f.value}
                          label={f.value}
                        />
                        {f.value === selectedFedbackOption ? commentBox({ commentlabel: f.commentLabel }) : <></>}
                      </>
                    ))}
                  </RadioGroup>
                  {submitFeedbackBtn()}
                </FormControl>
              </div>
            )}
          </>
        )
        : <></>}
      {showThankMsg && <Typography variant="body-copy-medium" className="thank-you-msg">Thank you. We&apos;ve recorded your feedback.</Typography>}
    </RootElement>
  );
};

const RootElement = styled.div`
  .thank-you-msg {
    border-top: 1px solid ${styleVariables.inkOnBackground};
    margin-top: 32px;
    padding-top: 32px;
  }
  .actions {
    padding: 30px 0;
    margin: 54px 0 12px 0; 
    display: flex;
    align-items: center;
    gap: 10px;
    border-top: 1px solid ${styleVariables.detail1Opaque};
    border-bottom: 1px solid ${styleVariables.detail1Opaque};
  }
  .feedback-panel {
    background-color: ${styleVariables.backgroundPanelColor};
    padding: 40px 40px 20px 30px;
    display: flex;
    flex-direction: column;

    .yes{
      margin: 0;
      .share-your-comments {
        margin: 0;
      }
    }
  }
  .MuiFormControl-root {
    margin: 20px 0;
  }
  .MuiFormControlLabel-label {
    font-size: 14px !important;
  }
  .MuiRadio-root {
    margin: 0;
  }
  .submit-feedback-btn {
    align-self: flex-start;
    margin-top: 10px;
  }
  .share-your-comments {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 20px 0 10px 30px;

    textarea {
      padding: 6px;
    }
    .comment-count {
      align-self: flex-end;
    }
  }
`;

WTIH.propTypes = {
  tutorialType: PropTypes.string,
  tutorialId: PropTypes.string,
  tutorialName: PropTypes.string,
  curatedId: PropTypes.string,
  curatedName: PropTypes.string,
  unitId: PropTypes.string,
  learningMode: PropTypes.string.isRequired,
};
WTIH.defaultProps = {
  tutorialType: '',
  tutorialId: '',
  tutorialName: '',
  curatedId: '',
  curatedName: '',
  unitId: '',
};
export default React.memo(WTIH);
